// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.dropdown-item-has-icon[data-v-4485ac04] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\nspan.dropdown-item-text[data-v-4485ac04] {\n  padding-left: 5px;\n}", ""]);
// Exports
module.exports = exports;
